import React, { useCallback, useEffect } from "react";
import { Image } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../store";
import ProjectTitle from "../components/ProjectTitle";
import { useApi } from "../api/contexts/ApiContext";
import { setFacilitiesId } from '../store/user/selectfacilitySlice';
import { resetFacilitiesId } from '../store/user/selectfacilitySlice';
import { api_url } from "../api/config/config";



interface Facility {
    id: number,
    contract_number: number,
    name: string,
    contract_start_date: string,
    pref: string,
    address: string,
    contract_type: string,
    category: number,
    usage_total: number,
    contract_usage: number,
    annual_load_factor_p: number,
    annual_load_factor_h: number,
    option_1: string,
    option_2: string,
    option_3: string,
    option_4: string,
    min_bid_amount: number,
    note: string,
    data_file_name: string,
    data_file_path: string,
    supplier_id: number,
    supplier: {
        name: string,
    }
    reseller: {
        name: string,
    },
    [key: string]: any;
}

interface OpportunityStructure {
    id: number,
    due: string,
    close_data: Date,
    company_id: number,
    name: string,
    industry: string,
    bids: {
        bid_id: number,
        status: number,
        upload_file_path: string,
        upload_file_name: string
    }[];
}

interface Company {
    id: number,
    due: string,
    close_date: string,
    created: string,
    company_name: string,
    industry: string,
    facility_count: number,
    usage_total: number,
    contract_usage: number,
    min_contract_start_date: string,
    max_contract_start_date: string,
    facilities: {},
    favorite: {},
    bids_count: number
}

interface DataStructure {
    no_file_count: number,
    file_count: number,
    status3_count: number,
    status4_count: number,
    company: Company[],
    [key: string]: any; // This allows any string to be used as an index
}

interface ResponseStructure {
    success: boolean;
    data: DataStructure;
}

const BidInitialState = {
    no_file_count: 0,
    file_count: 0,
    status3_count: 0,
    status4_count: 0,
    company: []
}

const BidStart: React.FC = () => {
    // const backendURL = 'http://localhost:8000';

    const { userInfo, userToken, error } = useSelector((state: RootState) => state.auth);
    const { vendorInfo, loading: vendorLoading, error: vendorError } = useSelector((state: RootState) => state.vendor);
    const [bid, setBid] = useState<DataStructure>(BidInitialState);
    const [page, setPage] = useState(1);
    const [companyCount, setCompanyCount] = useState(0);
    const [bidMode, setBidMode] = useState("all");
    const PER_PAGE = 9;
    const [status, setStatus] = useState(0);
    const { getModule } = useApi();
    const dispatch = useDispatch<AppDispatch>();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const opportunityId: number = parseInt(queryParams.get('opportunity_id') || '0', 10); // idを数値として取得

    const facilitiesId = useSelector((state: RootState) => state.selectFacilities.facilitiesId);
    const [countFacilities, setCountFacilities] = useState(0);
    const [alreadyBid, setAlreadyBid] = useState(false);
    const [opportunity, setOpportunity] = useState<OpportunityStructure>();
    const [facilities, setFacilities] = useState<Facility[]>([]);
    const [recs, setRecs] = useState<{ [key: string]: Facility[] }>({});
    // const [selected, setSelected] = useState(selectedFacilities || []);
    const [selected, setSelected] = useState<number[]>([]);
    const navigate = useNavigate();

    const handleCheckboxChange = (facilityId: number) => {
        setSelected((prevSelected) => prevSelected.includes(facilityId)
            ? prevSelected.filter(id => id !== facilityId)
            : [...prevSelected, facilityId]
        );

        // setSelected((prevSelected) =>
        //     prevSelected.includes(facilityId)
        //         ? prevSelected.filter(id => id !== facilityId)
        //         : [...prevSelected, facilityId]
        // );
    };

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (selected.length === 0) {
            alert('対象の施設を選択してください');
            return;
        }

        dispatch(setFacilitiesId(selected));
        navigate(`/bid?opportunity_id=${opportunityId}`);

    };


    const fetchOpportunity = useCallback(async () => {
        try {
            const response = await fetch(`${api_url}/api/enebid/getOpportunity?id=${opportunityId}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })

            const res = await response.json();
            if (res.data !== undefined) {
                setOpportunity(res.data);
            }

        } catch (error) {
            console.error('Error: ', error)
        }
    }, [opportunityId, userInfo?.id, userToken])

    const fetchFacilityByOpportunityId = useCallback(async () => {

        try {

            const FacilityApi = await getModule('FacilityApi');
            const response = await FacilityApi.getFacilityByOpportunityId({ opportunity_id: opportunityId });
            const facilities: any = response.data;
            setFacilities(facilities);


        } catch (error) {
            console.error('Error: ', error)
        }
    }, [opportunityId, userToken])

    useEffect(() => {
        if (facilitiesId.length > 0) {
            setSelected(facilitiesId);
            resetFacilitiesId();
        }
    }, [])


    // useEffect(() => {
    //     console.log(facilitiesId);
    // }, [facilitiesId])

    useEffect(() => {
        // fetchOpportunity();
        fetchFacilityByOpportunityId();
        // fetchHasAlreadyBid();
    }, [fetchFacilityByOpportunityId, fetchOpportunity])

    return (

        <>
            <section className="section-name project-details-section info-dispaly">
                <div className="container">
                    <div className="project-details mb-lg-5 mb-4">
                        {/* <ProjectTitle /> */}
                    </div>
                    <div className="bg-white text-center rounded-pill text-sm py-1 fw-300 mb-3">
                        <img className="img img-fluid height-25 mb-1 mr-2" src="assets/images/other/icon-building-level.svg" alt="Building Icon" />
                        応札する施設を選択
                    </div>
                    <div className="bg-ass-demo p-4 mb-5">
                        <form onSubmit={handleSubmit}>
                            <input type="hidden" name="bid_mode" value={bidMode} />
                            <div className="row">
                                {facilities && facilities.map((facility) => (
                                    <div className="col-lg-4" key={facility.id}>
                                        <label className={`product-block mb-30 ${selected.includes(facility.id) ? 'bg-green-04' : 'bg-white'}`}>
                                            <input
                                                type="checkbox"
                                                name="selected"
                                                value={facility.id}
                                                checked={selected.includes(facility.id)}
                                                onChange={() => handleCheckboxChange(facility.id)}
                                                style={
                                                    { opacity: 0, position: 'absolute', display: 'none' }
                                                }
                                            />
                                            <div className="product-body border-0 pb-0">
                                                <div className="row mx-0 mb-3">
                                                    <div className="mb-2 w-100">
                                                        <img className="img img-fluid product-title-img mr-1 d-inline-block" src="assets/images/mypage/product-brand.svg" alt="Brand Icon" />
                                                        <h2 className="product-title d-inline-block fw-400">{facility.name}</h2>
                                                    </div>
                                                    <div>
                                                        <div className="w-min-90 d-inline-block">所在地</div>
                                                        <div className="d-inline-block">{facility.address}</div>
                                                    </div>
                                                    <div>
                                                        <div className="w-min-90 d-inline-block">供給地点番号</div>
                                                        <div className="d-inline-block">{facility.contract_number || "XX-XXXX-XXXX-XXXX-XXXX-XXXX"}</div>
                                                    </div>
                                                </div>
                                                <div className="product-details">
                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-4 px-0">
                                                            <div className="product-left-contents">送配電事業者</div>
                                                        </div>
                                                        <div className="col-8 px-0 text-center">
                                                            <div className="product-right-contents text-xs fw-300 line-height-1">{facility.supplier.name}</div>
                                                        </div>
                                                    </div>
                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-4 px-0">
                                                            <div className="product-left-contents">使用量電力</div>
                                                        </div>
                                                        <div className="col-8 px-0 text-center">
                                                            <div className="product-right-contents">
                                                                <span className="text-xs fw-300 line-height-1">{facility.usage_total}</span>
                                                                <span className="float-right fw-300">kWh</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-4 px-0">
                                                            <div className="product-left-contents">契約電力</div>
                                                        </div>
                                                        <div className="col-8 px-0 text-center">
                                                            <div className="product-right-contents">
                                                                <span className="text-xs fw-300 line-height-1">{facility.contract_usage}</span>
                                                                <span className="float-right fw-300"> {facility.category != 4 ? 'kW' : 'kVA'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-4 px-0">
                                                            <div className="product-left-contents">負荷率</div>
                                                        </div>
                                                        <div className="col-8 px-0 text-center">
                                                            <div className="product-right-contents">
                                                                <span className="text-xs fw-300 line-height-1">{Math.round(facility.annual_load_factor_p * 10) / 10}</span>
                                                                <span className="float-right fw-300">％</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-4 px-0">
                                                            <div className="product-left-contents">希望の料金体系</div>
                                                        </div>
                                                        <div className="col-8 px-0 text-center">
                                                            <div className="product-right-contents">
                                                                <div className="img-wrapper">
                                                                    <img
                                                                        className="img img-fluid"
                                                                        src={`assets/images/mypage/chart-bar${facility.contract_type === "LOAD_FACTOR" ? "-blue" : ""}.svg`}
                                                                        alt="Load Factor"
                                                                    />
                                                                    <p className={facility.contract_type !== "LOAD_FACTOR" ? "text-ass-demo" : ""}>負荷率</p>
                                                                </div>
                                                                <div className="px-3 img-wrapper">
                                                                    <img
                                                                        className="img img-fluid"
                                                                        src={`assets/images/mypage/calendar${facility.contract_type === "SEASONAL_HOLIDAYS" ? "-blue" : ""}.svg`}
                                                                        alt="Seasonal Holidays"
                                                                    />
                                                                    <p className={facility.contract_type !== "SEASONAL_HOLIDAYS" ? "text-ass-demo" : ""}>曜日別</p>
                                                                </div>
                                                                <div className="img-wrapper">
                                                                    <img
                                                                        className="img img-fluid"
                                                                        src={`assets/images/mypage/clock${facility.contract_type === "SEASON_TIME_ZONE" ? "-blue" : ""}.svg`}
                                                                        alt="Season Time Zone"
                                                                    />
                                                                    <p className={facility.contract_type !== "SEASON_TIME_ZONE" ? "text-ass-demo" : ""}>時間別</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="white-this height-35"></div>
                                            <div className="green-this text-center py-1 px-2 bg-green-02 text-xs text-white" style={{ display: selected.includes(facility.id) ? 'block' : 'none' }}>選択中</div>
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <div className="text-center mb-lg-4 mb-4">
                                <button type="submit" className="btn btn-lg btn-theme btn-danger rounded-pill px-lg-5 px-3 mr-2">
                                    <span className="mx-3">次へ</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );

    // return (
    //     <>
    //     <Header 
    //         mode="company"
    //         vendor={{ companyName: "エネクラウド株式会社（電力会社テスト）", lastName: userInfo?.lastName, firstName: userInfo?.firstName }} /> 

    //     <Footer />
    //     </>
    // );
}

export default BidStart;